import React from "react";
import { useState } from "react";
import { Container, Nav, Offcanvas } from "react-bootstrap";
import OffCanvasChild from "./OffCanvasChild";
import { MdArrowBackIos } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";
import "./OffCanvas.scss";
const OffCanvas = ({ show, setShow, data, parentName, setShowNav }) => {
  const [show2, setShow2] = useState(false);
  const [child, setChild] = useState([]);

  return (
    <Offcanvas
      show={show}
      placement="end"
      style={{ backgroundColor: "#F8F9FA", marginTop: "17px" }}
      className="off_canvas_background"
    >
      <Offcanvas.Header
        onClick={() => {
          setShow(false);
        }}
        style={{
          cursor: "pointer",
          padding: "0",
          lineHeight: "2.6rem",
        }}
      >
        <div className="d-flex align-items-center border-bottom border-top w-100">
          <div
            className="back_button_hover"
            style={{
              height: "50px",
              width: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRight: "1.5px solid #e8e8e8",
            }}
          >
            <MdArrowBackIos style={{}} />
          </div>

          <div
            className="ps-3 text-uppercase d-flex align-items-center"
            style={{
              width: "100%",
              height: "50px",
              color: "#08c",
              fontWeight: "600",
            }}
          >
            {parentName}
          </div>
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body style={{ padding: "0" }}>
        {data.length > 0 &&
          data.map((parent) => (
            <div key={parent._id}>
              <p
                className="d-flex justify-content-between align-items-center off_canvas_link"
                onClick={() => {
                  setChild(parent);
                  setShow2(true);
                }}
                style={{
                  fontSize: "0.875rem",
                  letterSpacing: "0.125rem",
                  lineHeight: "3rem",
                  borderBottom: "1px solid #e8e8e8",
                  textTransform: "capitalize",
                  paddingLeft: "70px",
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                {parent.title}
                {data.length > 0 && (
                  <MdArrowForwardIos
                    onClick={() => setShow(true)}
                    style={{ width: "3.375rem" }}
                  />
                )}
              </p>
            </div>
          ))}
      </Offcanvas.Body>
      <OffCanvasChild
        show2={show2}
        setShow2={setShow2}
        setShow={setShow}
        child={child}
        setShowNav={setShowNav}
      />
    </Offcanvas>
  );
};

export default OffCanvas;
